/*
  Subscribe and save in the cart, on every page while the option is on
  (layout/theme.liquid).

  - "Change to one-time" on a subscribed line puts the same lenses back without
    the subscription (the cart API cannot clear line properties, so the line is
    removed and re-added).
  - The SUBSCRIPTION10 code stays only while the cart has a subscribed line: with
    none left it is taken off, so a one-time purchase never gets the 10% (TickOS
    would otherwise enrol those lines). With a subscribed line and no code at all,
    the code is put back.
*/
(() => {
  const CODE = 'SUBSCRIPTION10';
  const arabic = (document.documentElement.lang || '').toLowerCase().startsWith('ar');
  const ONE_TIME = arabic ? 'تغيير إلى شراء لمرة واحدة' : 'Change to one-time';

  const flagged = () => {
    try {
      return localStorage.getItem('eyenk-sub') === '1';
    } catch (error) {
      return true;
    }
  };
  const unflag = () => {
    try {
      localStorage.removeItem('eyenk-sub');
    } catch (error) {}
  };
  const json = async (url, options) => (await fetch(url, { headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, ...options })).json();
  const subscribed = (item) => Boolean(item && item.properties && item.properties._subscription_interval_days);

  let checking = false;
  async function keepCodeInStep({ reloadIfChanged = false } = {}) {
    if (checking || !flagged() || !window.routes) return;
    checking = true;
    try {
      const cart = await json(`${window.routes.cart_url}.js`);
      const codes = (cart.discount_codes || []).map((entry) => String(entry.code || '').toUpperCase()).filter(Boolean);
      const hasSubscription = (cart.items || []).some(subscribed);
      let next = null;
      if (!hasSubscription && codes.includes(CODE)) next = codes.filter((code) => code !== CODE).join(',');
      else if (hasSubscription && codes.length === 0) next = CODE;
      if (!hasSubscription) unflag();
      if (next === null) return;
      await json(`${window.routes.cart_update_url}.js`, { method: 'POST', body: JSON.stringify({ discount: next }) });
      if (reloadIfChanged) window.location.reload();
    } catch (error) {
      console.error(error);
    } finally {
      checking = false;
    }
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-sub-one-time]');
    if (!button) return;
    event.preventDefault();
    button.setAttribute('aria-disabled', 'true');
    try {
      const quantity = Number(button.dataset.lineQty) || 1;
      await json(`${window.routes.cart_change_url}.js`, {
        method: 'POST',
        body: JSON.stringify({ id: button.dataset.lineKey, quantity: 0 }),
      });
      await json(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity }] }),
      });
      await keepCodeInStep();
    } catch (error) {
      console.error(error);
    }
    window.location.reload();
  });

  const label = () => document.querySelectorAll('[data-sub-one-time]').forEach((button) => {
    button.textContent = ONE_TIME;
  });

  document.addEventListener('DOMContentLoaded', () => {
    label();
    keepCodeInStep({ reloadIfChanged: window.location.pathname.endsWith('/cart') });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        label();
        keepCodeInStep();
      });
    }
  });
})();
